import { createSlice } from '@reduxjs/toolkit';

export interface ApplicationFormSliceState {
    errors?: string[];
}

export const ApplicationFormSlice = createSlice({
    name: 'applicationForm',
    initialState: {
        errors: [],
    },
    reducers: {
        setErrors: (state, action) => {
            state.errors = action.payload;
        },
        clearErrors: (state, action) => {
            state.errors = [];
        },
    },
});

export default ApplicationFormSlice
export const ApplicationFormActions = ApplicationFormSlice.actions
export const ApplicationFormSelector = (store: { applicationForm: ApplicationFormSliceState }): ApplicationFormSliceState => store.applicationForm;
import { createSlice } from '@reduxjs/toolkit';

export interface ApplicationFormSliceState {
    errors?: string[];
}

export const ApplicationFormSlice = createSlice({
    name: 'applicationForm',
    initialState: {
        errors: [],
    },
    reducers: {
        setErrors: (state, action) => {
            state.errors = action.payload;
        },
        clearErrors: (state, action) => {
            state.errors = [];
        },
    },
});

export default ApplicationFormSlice
export const ApplicationFormActions = ApplicationFormSlice.actions
export const ApplicationFormSelector = (store: { applicationForm: ApplicationFormSliceState }): ApplicationFormSliceState => store.applicationForm;
